import PropTypes from 'prop-types'

const operationTypeShape = PropTypes.shape({
    qualitometer: PropTypes.number, // double
    id: PropTypes.number, // Double
    date: PropTypes.number, // DateTime,
    length: PropTypes.number, // Option[Double] = None,
    mediumWidth: PropTypes.number, // Option[Double] = None,
    interpretation: PropTypes.string, // Option[String] = None,
    qualification: PropTypes.number, // Option[Double] = None,
    status: PropTypes.number, // Option[Double] = None,
    comment: PropTypes.string, // Option[String] = None,
    methodOfPrincipalConservation: PropTypes.number, // Option[Double] = None,
    methodOfSecondConservation: PropTypes.number, // Option[Double] = None,
    wetArea: PropTypes.number, // Option[Double] = None,
    particularSituation: PropTypes.number, // Option[Double] = None,
    point: PropTypes.number, // Option[Double],
    determiner: PropTypes.number, // Option[Double] = None,
    producer: PropTypes.number, // Option[Double] = None,
    sampler: PropTypes.number, // Option[Double] = None,
    support: PropTypes.number, // Option[Double] = None,
    method: PropTypes.number, // Option[Double] = None,
    speed: PropTypes.string, // Option[String] = None,
    shady: PropTypes.number, // Option[Double] = None,
    continu: PropTypes.string, // Option[String] = None,
    resultComment: PropTypes.string, // Option[String] = None,
    microSampling: PropTypes.string, // Option[String] = None,
    seasonality: PropTypes.number, // Option[Double] = None,
    localization: PropTypes.string, // Option[String] = None,
    producerContact: PropTypes.number, // Option[Double] = None,
    samplerContact: PropTypes.number, // Option[Double] = None,
    determinerContact: PropTypes.number, // Option[Double] = None,
    jobExecutionId: PropTypes.number, // Option[Long] = None,
    analysisMethod: PropTypes.number, // Option[Long] = None,
    accreditation: PropTypes.string, // Option[String] = None,
    authorizationBanking: PropTypes.string, // Option[String] = None,
    campaign: PropTypes.number, // Option[Double] = None,
    updateDate: PropTypes.number, // Option[DateTime] = None,
    updateLogin: PropTypes.string, // Option[String] = None,
    dateDetermination: PropTypes.number, // Option[DateTime] = None

})

const selectionParameterShape = PropTypes.shape({
    code: PropTypes.string,
    name: PropTypes.string,
    parentCode: PropTypes.string,
    num: PropTypes.number,
    parameterCode: PropTypes.string,
    unitCode: PropTypes.string,
    listType: PropTypes.number,
    childCode: PropTypes.string,
})

const pocheShape = PropTypes.shape({
    qualitometer: PropTypes.number.isRequired, // Double
    operation: PropTypes.number.isRequired, // Double
    taxon: PropTypes.number.isRequired, // Int
    sampling: PropTypes.number.isRequired, // Int
    unit: PropTypes.string, // Option[String]
    remark: PropTypes.number, // Option[Int]
    deadCount: PropTypes.number, // Option[Int]
    initialTotalWeight: PropTypes.number, // Option[Double]
    totalWeight: PropTypes.number, // Option[Double]
    growth: PropTypes.number, // Option[Double]
    development: PropTypes.number, // Option[Int]
    size: PropTypes.number, // Option[Int]
})

export { operationTypeShape, selectionParameterShape, pocheShape }